export default __webpack_public_path__ + "static/media/unknown.cd239edd.svg";